module.exports = __webpack_public_path__ + "img/img1.51af6b69.jpg";